module.exports = new __parcel__URL__("forest-grass.2edc1389.webp").toString();